import axios from 'axios';
import { appEnv } from '../constants/appEnv';

class axiosGatewayApi {
    static get(endpoint) {
        let nowUtc = Date.now();
        let isGatewayTokenExpired = (digitalData.microServiceInfo.Gateway.expirationUtc < nowUtc);
        if (isGatewayTokenExpired) {
            return axios.get(appEnv.baseApiUrl + "/MicroServiceInfo").then(response => {
                digitalData.microServiceInfo.Gateway = response.data.gateway;
                return axios.get(digitalData.microServiceInfo.Gateway.uri + endpoint, { headers: { "Authorization": digitalData.microServiceInfo.Gateway.token } }).then(response => {
                    return response.data;
                }).catch(error => {
                    return error;
                });
            });
        }
        else {
            return axios.get(digitalData.microServiceInfo.Gateway.uri + endpoint, { headers: { "Authorization": digitalData.microServiceInfo.Gateway.token } }).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        }
    }
}

export default axiosGatewayApi;  